module.exports = __webpack_public_path__ + "img/machine.fd9ccf6a.jpg";